import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在 - 抖阳",
    description: "你访问的页面不存在或已被移除，返回抖阳首页继续浏览原创文章与视频内容。",
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 items-center px-4 py-20 md:px-6">
        <div className="mx-auto w-full max-w-[900px] text-center">
          <p className="font-editorial text-6xl font-bold text-background-300 md:text-8xl">404</p>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            这个页面走丢了
          </h1>
          <p className="mt-3 text-sm text-foreground-500">
            地址 <span className="font-mono text-foreground-700">{location.pathname}</span> 对应的内容不存在，可能已被移动。
          </p>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              返回首页
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/search?q=城市"
              className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              搜索内容
              <i className="ri-search-line" />
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}